/*
  <sticky-atc data-target="#FormId">: mobile buy bar. Shows once the main
  add-to-cart button has scrolled above the viewport, hides again when the
  button (or the footer) is visible.
*/
if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const form = document.querySelector(this.dataset.target);
      const anchor = form?.querySelector('[type="submit"]');
      if (!anchor) return;
      this.hidden = false;

      this.observer = new IntersectionObserver(([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', scrolledPast);
      });
      this.observer.observe(anchor);

      const footer = document.querySelector('.site-footer');
      if (footer) {
        this.footerObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) this.classList.remove('is-visible');
        });
        this.footerObserver.observe(footer);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.footerObserver?.disconnect();
    }
  }
  customElements.define('sticky-atc', StickyAtc);
}
